var map = {
	"./color01_on.png": 79150,
	"./color02_on.png": 70063,
	"./color03_on.png": 75346,
	"./color04_on.png": 88887,
	"./color05_on.png": 62033,
	"./color06_on.png": 21011,
	"./color07_on.png": 32989,
	"./color08_on.png": 21288,
	"./color09_on.png": 76887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55195;